import { create } from "zustand";
import { persist } from "zustand/middleware";
import { roleDefaultModules } from "@/domain/access";
import { ALL_COMPANY_IDS } from "@/domain/tenantUsers";

const defaultEntitlements = {
  phase1: true,
  phase2: true,
  phase3: true,
  phase4: true,
  phase5: true,
};

const useAccessStore = create()(
  persist(
    (set, get) => ({
      role: "group_admin",
      entitlements: defaultEntitlements,
      permissions: [],
      activeCompanyId: "shivshankar",
      allowedCompanyIds: ALL_COMPANY_IDS,
      setRole: (role) => set({ role }),
      setAllowedCompanyIds: (ids) => set({ allowedCompanyIds: ids }),
      bindSessionAccess: (role, companyIds, permissions = [], modules) => {
        set((state) => ({
          role,
          allowedCompanyIds: companyIds,
          permissions,
          entitlements: modules ? { ...modules } : state.entitlements,
          activeCompanyId: companyIds.includes(state.activeCompanyId)
            ? state.activeCompanyId
            : (companyIds[0] ?? state.activeCompanyId),
        }));
      },
      setEntitlements: (entitlements) => set({ entitlements }),
      toggleEntitlement: (key) =>
        set((state) => ({
          entitlements: {
            ...state.entitlements,
            [key]: !state.entitlements[key],
          },
        })),
      setActiveCompany: (companyId) => set({ activeCompanyId: companyId }),
      isModuleEnabled: (key) => get().entitlements[key],
    }),
    { name: "gps-erp-next-access" },
  ),
);

function effectiveModules(role, entitlements) {
  return roleDefaultModules(role).filter((m) => entitlements[m]);
}

export { effectiveModules, useAccessStore };
